import React from 'react'
import { CrossClientLanding } from './Landing/CrossClientLanding'
import { useZocksAuth, useZocksQuota } from '../../components/ScopedBlock/hooks'
import { CrossClientWaitlist } from './Waitlist/CrossClientWaitlist'
import { useCookies } from 'react-cookie'
import { CrossClientUnauthorized } from './Unauthorized/CrossClientUnauthorized'

const CROSS_CLIENT_COOKIE = 'omn8xHPqcIjch0vyFWCY'

export const CrossClient: React.FC = () => {
  const { hasQuota, isFetching: quotaIsFetching } = useZocksQuota()
  const { hasScope } = useZocksAuth()

  const crossClientAvailable = hasQuota('ai.crossClientQuery.value')
  const hasCrossClientExecutePermission = hasScope('**', 'cross_client_query:execute', ['cross_client_query:admin'])

  const [cookies] = useCookies([CROSS_CLIENT_COOKIE])

  if (quotaIsFetching) {
    return null
  }

  const shouldShowWaitlist = !crossClientAvailable && !cookies[CROSS_CLIENT_COOKIE]

  if (shouldShowWaitlist) {
    return <CrossClientWaitlist />
  }

  if (!hasCrossClientExecutePermission) {
    return <CrossClientUnauthorized />
  }

  return <CrossClientLanding />
}
